import { Color } from '@pixi/color';
import { Container, Graphics } from 'pixi.js-legacy';

import { themingInstance } from '@exchange/libs/utils/theming/src';

import DataPoint from './pixi-datapoint';
import FooterIndicator from './pixi-footer-indicator';

export default class Footer extends Container {
  private graphics = new Graphics();

  private askLabel: FooterIndicator;

  private bidLabel: FooterIndicator;

  private get backgroundColor() {
    return new Color(themingInstance.getColor('--v-theme-elevation-1')).toNumber();
  }

  constructor(
    private fontName: string,
    private mouseDataPoint: DataPoint,
    public footerWidth: number,
    public footerHeight: number,
    public footerY: number,
    private getFormattedNumber: (value: number, isMarketPrecision?: boolean) => string,
  ) {
    super();
    this.sortableChildren = true;
    this.width = footerWidth;
    this.height = footerHeight;
    this.y = footerY;

    const borderWidth = 0;
    const rightPadding = 10;
    const xLimit = footerWidth - rightPadding;

    this.askLabel = new FooterIndicator({
      fontName: this.fontName,
      isAsk: true,
      xLimit,
      containerBorderWidth: borderWidth,
      getFormattedNumber: this.getFormattedNumber,
    });
    this.bidLabel = new FooterIndicator({
      fontName: this.fontName,
      isAsk: false,
      xLimit,
      containerBorderWidth: borderWidth,
      getFormattedNumber: this.getFormattedNumber,
    });

    // Background
    this.graphics.beginFill(this.backgroundColor);

    this.graphics.drawRect(0, 0, footerWidth, footerHeight);
    this.graphics.endFill();

    // Border between footer and graph
    this.graphics.beginFill(new Color(themingInstance.getColor('--v-theme-elevation-1')).toNumber());
    this.graphics.drawRect(0, 0, footerWidth, borderWidth);
    this.graphics.endFill();

    this.addChild(this.graphics, this.askLabel, this.bidLabel);
  }

  public update(): void {
    if (this.mouseDataPoint.isInsideCanvas) {
      this.askLabel.update(this.mouseDataPoint.askPosition, false, true);
      this.bidLabel.update(this.mouseDataPoint.bidPosition, false, true);
    } else if (this.mouseDataPoint.lastVisibleAsk) {
      const isAskBigger = this.mouseDataPoint.lastVisibleAsk.size > this.mouseDataPoint.lastVisibleBid.size;

      this.askLabel.update(this.mouseDataPoint.lastVisibleAsk, true, isAskBigger);
      this.bidLabel.update(this.mouseDataPoint.lastVisibleBid, true, !isAskBigger);
    }
  }
}
